var map = {
	"./BActions.json": 321,
	"./BFactory.json": 322,
	"./BPool.json": 323,
	"./BuniCornFactory.json": 324,
	"./BuniCornPool.json": 325,
	"./BuniCornRouter02.json": 326,
	"./CRPFactory.json": 327,
	"./ConfigurableRightsPool.json": 328,
	"./DSProxy.json": 329,
	"./DSProxyRegistry.json": 330,
	"./ERC20.json": 331,
	"./ExchangeProxy.json": 332,
	"./ExchangeProxyCallable.json": 333,
	"./LPErc20.json": 334,
	"./MasterChef.json": 335,
	"./Multicall.json": 121,
	"./StakingReward.json": 336,
	"./StakingRewardFactory.json": 337,
	"./TestToken.json": 338,
	"./VBuni.json": 339,
	"./Weth.json": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 320;